enum HeadingClass {
  H1 = 'H1',
  H2 = 'H2',
  H3 = 'H3',
  H4 = 'H4',
  H5 = 'H5',
  H6 = 'H6',
  altH1 = 'altH1',
  altH2 = 'altH2',
  altH3 = 'altH3',
  altH4 = 'altH4',
  altH5 = 'altH5',
  altH6 = 'altH6'
}

enum HeadingType {
  H1 = 'H1',
  H2 = 'H2',
  H3 = 'H3',
  H4 = 'H4',
  H5 = 'H5',
  H6 = 'H6',
  altH1 = 'altH1',
  altH2 = 'altH2',
  altH3 = 'altH3',
  altH4 = 'altH4',
  altH5 = 'altH5',
  altH6 = 'altH6',
  P = 'P'
}

export { HeadingType, HeadingClass }
